import React, { } from 'react';
import { Container, Row, Col, Input, Button } from 'reactstrap';
import FormRenderField from './FormRenderField';
import FormEntries from './FormEntries';

class FormDisplay extends React.Component {
    constructor(props) {
        super(props);

        let obj = {};


        this.state = {
            formEntries: [],
            formFields: [],
            selectedFormEntry: this.props.selectedFormEntry > 0 ? this.props.selectedFormEntry : 0,
            data: [],
            config: {},
            criteria: {},
            criteriaString: '',
            filter: {},
            display: false,
            selection: obj,
            autofocus: true,
            sort: '',
            sortType: 'text',
            sortAsc: true,
            joinData: {},
            targetFields: null,
            targetFieldsValue: null,
            userCreated: {},
            userUpdated: {}
        }
        this.inputFocus = React.createRef();

    }

    componentDidMount = () => {
        this.props.log('FormDisplay.js/componentDidMount (formId)', this.props.formId);
        if (this.props.setCallback != null) this.props.setCallback(this.props.tab, this.loadFormData);
    }

    loadFormData = () => {
        this.props.log('FormsContainer.js/loadFormData');
        this.getForm(this.props.formId);
    }

    setFocus = () => {
        this.props.log('FormsContainer.js/setFocus [this.inputFocus.current]', this.inputFocus);
        if (this.inputFocus.current != null && this.state.autofocus) {
            this.inputFocus.current.focus();
        }
    }

    getForm = (formId) => {
        this.props.log('FormsContainer.js/getForms (formId)', formId);
        fetch('/api/forms/' + formId + '/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-DB': this.props.clientId
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    const config = results.data[0].config != null && results.data[0].config !== '' ?
                        JSON.parse(results.data[0].config.replaceAll('\n', '')) : null;
                    let obj = {
                        config: config,
                        sort: config.rowOrder != null ? config.rowOrder.uniqueId : '',
                        sortType: config.rowOrder != null ? config.rowOrder.type : 'text',
                        sortAsc: config.rowOrder != null ? config.rowOrder.asc : true,
                        formFields: results.data[0].formFields,
                        originalData: this.setFormState(results.data[0].formFields, 0, {})
                    }
                    if (this.props.selectedFormEntry > 0) { } else { obj.data = this.setFormState(results.data[0].formFields, 0, {}) }
                    this.setState(obj, () => {
                        if (this.props.selectedInvestor != null && this.props.selectedInvestor !== '') {
                            setTimeout(() => { this.onChangeField('companyNameSelect', this.props.selectedInvestor) }, 200);
                        }
                        if (this.props.selectedFund != null && this.props.selectedFund !== '') {
                            setTimeout(() => { this.onChangeField('fundSelect', this.props.selectedFund) }, 400);
                        }
                        this.getFormEntries()
                    });
                } else {
                    this.props.addToast('Unable to load form.', 5, 'danger');
                }
            })
            // .catch(() => {
            //     this.props.addToast('An error has occurred attempting to load a form.', 5, 'danger');
            // })
    }

    getFormEntries = () => {
        this.props.log('Client.js/getFormEntries');
        if (this.state.config.criteria != null) {
            this.state.config.criteria.forEach(criteria => {
                if (criteria.filter == null) {
                    this.getFormFields(criteria.uniqueId);
                }
                // else {
                //     if (this.state.selection[criteria.filter] != null && this.state.selection[criteria.filter] !== -1)
                //         this.getFormFields(criteria.uniqueId,criteria.filter);
                // }
            })
            this.state.config.criteria.forEach(criteria => {
                this.getJoinFormData(criteria);
            });
        }
        fetch('/api/get-form-entries/', {
            method: 'POST',
            body: JSON.stringify({
                formId: this.state.config.dataForm != null ? this.state.config.dataForm : this.props.formId,
                criteria: this.state.criteriaString,

            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-DB': this.props.clientId
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setFocus();
                    this.setState({
                        formEntries: results.data,
                        autofocus: false
                    });
                    if (results.data.length > 0 && this.state.config.limit) this.loadData(results.data[0]);
                    if (this.state.selectedFormEntry > 0) {
                        const index = results.data.findIndex(row => row.formEntryId === this.state.selectedFormEntry);
                        if (index > -1) {
                            this.loadData(results.data[index]);
                        }
                    }
                } else {
                    this.props.addToast('Form entries are not available.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred attempting to get form entries.', 5, 'danger');
            })
    }

    getFormFields = (field, filter) => {
        this.props.log('Client.js/getFormFields (field,filter)', field, filter);
        let obj;
        if (filter) {
            obj = {};
            obj[filter] = this.state.selection[filter]
            obj = JSON.stringify([obj]);
        };
        fetch('/api/form-field/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-DB': this.props.clientId
            },
            body: JSON.stringify({
                criteria: field,
                filter: obj
            })
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState((prevState) => {
                        let sel = prevState;
                        sel.criteria[field] = results.data;
                        return sel;
                    });
                } else {
                    this.props.addToast('Form field is not available.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred attempting to get form fields.', 5, 'danger');
            })
    }

    isCriteriaMet = () => {
        if (this.state.config.criteria == null || (this.state.config.criteria != null && this.state.config.criteria.length === 0)) return true;
        let isMet = true;
        this.state.config.criteria.forEach(criteria => {
            if (criteria.required && this.state.criteria[criteria.uniqueId] != null && (this.state.selection[criteria.uniqueId] == null || this.state.selection[criteria.uniqueId] === '-1')) isMet = false;
        });
        return isMet;
    }

    deleteEntry = (formEntryId) => {
        this.props.log('Client.js/deleteEntry (formEntryId)', formEntryId);
        fetch('/api/form-entries/' + formEntryId, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-DB': this.props.clientId
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.props.addToast('Form entry deleted successfully.', 5, 'success')
                    this.setState({
                        selectedFormEntry: 0,
                        userCreated: {},
                        userUpdated: {},
                        data: this.setFormState(this.state.formFields, {})
                    }, () =>
                        this.getFormEntries())
                } else {
                    this.props.addToast('Unable to delete form entry.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred attempting to delete a form entry.', 5, 'danger');
            })
    }

    setFormState = (fields, submitObj) => {
        this.props.log('FormDisplay.js/setFormState (fields,submitObj)', fields, submitObj);
        let retObj = {};
        fields.filter(field => field.field !== '' && field.uniqueId !== '' && field.type !== 'header').forEach(field => {
            switch (field.type) {
                case "boolean":
                case "radio":
                    retObj[field.uniqueId] = (field.default != null && field.default !== '') ?
                        (field.default.toLowerCase().indexOf('same') > -1 && Object.keys(submitObj).length > 0 ?
                            submitObj[field.uniqueId]
                            : this.unsetDefaults(field.default)) : '';
                    break;
                case "select":
                    retObj[field.uniqueId] = (field.default != null && field.default !== '') ?
                        (field.default.toLowerCase().indexOf('same') > -1 && Object.keys(submitObj).length > 0 ?
                            submitObj[field.uniqueId]
                            : field.default) :
                        (field.options != null && field.options[0].default != null && field.options[0].default !== '' ?
                            this.unsetDefaults(field.options[0].default) :
                            '-1');
                    break;
                case "date":
                    retObj[field.uniqueId] = (field.default != null && field.default !== '') ?
                        ((field.default.toLowerCase().indexOf('today') > -1 && (submitObj[field.uniqueId] == null || submitObj[field.uniqueId] === '')) ?
                            this.formatDate(new Date()) :
                            (field.default.toLowerCase().indexOf('same') > -1 && Object.keys(submitObj).length > 0 ?
                                submitObj[field.uniqueId]
                                : this.unsetDefaults(this.formatDate(field.default)))
                        ) : '';
                    break;
                case "number":
                    retObj[field.uniqueId] = (field.default != null && field.default !== '') ?
                        (field.default.toLowerCase().indexOf('same') > -1 && Object.keys(submitObj).length > 0 ?
                            submitObj[field.uniqueId]
                            : this.unsetDefaults(field.default))
                        : 0;
                    break;
                default:
                    retObj[field.uniqueId] = (field.default != null && field.default !== '') ?
                        (field.default.toLowerCase().indexOf('same') > -1 && Object.keys(submitObj).length > 0 ?
                            submitObj[field.uniqueId]
                            : this.unsetDefaults(field.default))
                        : '';
                    break;
            }
        });
        return retObj;
    }

    unsetDefaults = (str) => {
        this.props.log('FormDisplay.js/unsetDefaults (str)', str);
        return str.replace('same', '').replace('today', '');
    }

    testRule = (formField, ruleSet, sel) => {
        this.props.info('FormDisplay.js/testRule (formField, ruleSet)', formField, ruleSet);
        let rulePass = true;
        let changed = false;
        formField.rules[ruleSet].filter(rule => rule.key != null && rule.operator != null && rule.value != null).forEach(rule => {
            if (!changed) {
                switch (rule.operator) {
                    case "<":
                        if (isNaN(parseFloat(sel.data[rule.key])) || parseFloat(sel.data[rule.key]) >= parseFloat(rule.value)) rulePass = false;
                        if (!isNaN(parseFloat(sel.data[rule.key])) && parseFloat(sel.data[rule.key]) < parseFloat(rule.value)) { rulePass = true; changed = true; }
                        break;
                    case "<=":
                        if (isNaN(parseFloat(sel.data[rule.key])) || parseFloat(sel.data[rule.key]) > parseFloat(rule.value)) rulePass = false;
                        if (!isNaN(parseFloat(sel.data[rule.key])) && parseFloat(sel.data[rule.key]) <= parseFloat(rule.value)) { rulePass = true; changed = true; }
                        break;
                    case ">":
                        if (isNaN(parseFloat(sel.data[rule.key])) || parseFloat(sel.data[rule.key]) <= parseFloat(rule.value)) rulePass = false;
                        if (!isNaN(parseFloat(sel.data[rule.key])) && parseFloat(sel.data[rule.key]) > parseFloat(rule.value)) { rulePass = true; changed = true; }
                        break;
                    case ">=":
                        if (isNaN(parseFloat(sel.data[rule.key])) || parseFloat(sel.data[rule.key]) < parseFloat(rule.value)) rulePass = false;
                        if (!isNaN(parseFloat(sel.data[rule.key])) && parseFloat(sel.data[rule.key]) >= parseFloat(rule.value)) { rulePass = true; changed = true; }
                        break;
                    case "!=":
                        if (String(sel.data[rule.key]).trim().toLowerCase() === String(rule.value).trim().toLowerCase()) { rulePass = false; changed = true; }
                        // if (String(sel.data[rule.key]).trim().toLowerCase() !== String(rule.value).trim().toLowerCase()) { rulePass = true; changed = true; }
                        break;
                    default:
                        if (String(sel.data[rule.key]).trim().toLowerCase() !== String(rule.value).trim().toLowerCase()) rulePass = false;
                        if (String(sel.data[rule.key]).trim().toLowerCase() === String(rule.value).trim().toLowerCase()) { rulePass = true; changed = true; }

                }
            }
        })
        return rulePass;
    }

    onChange = (e) => {
        this.props.log('FormDisplay.js/onChange (e)', e.target.name, e.target.value, e.target.type, e);
        e.persist();
        let sel = { ...this.state };
        if (String(e.target.name).indexOf('|') > -1) {
            let nameArr = String(e.target.name).split('|');
            if (typeof (sel.data[nameArr[0]]) !== 'object') {
                sel.data[nameArr[0]] = [];
            }
            let nameObj = { ...sel.data[nameArr[0]][parseInt(nameArr[1])] };
            nameObj[nameArr[2]] = (e.target.type !== 'checkbox') ? e.target.value : !sel.data[e.target.name];
            nameObj[nameArr[2] + '-changed'] = true;
            sel.data[nameArr[0]][parseInt(nameArr[1])] = nameObj;
        } else {
            sel.data[e.target.name] = (e.target.type !== 'checkbox') ? e.target.value : !sel.data[e.target.name];
            sel.data[e.target.name + '-changed'] = true;
        }
        this.getTargetFormFields(e.target.name, e.target.value, sel, false);
        this.setState(this.applyRules(sel));
    }

    applyRules = (sel) => {
        this.props.info('FormDisplay.js/applyRules (sel)', sel);
        this.state.formFields.filter(formField => Object.keys(formField.rules).length > 0).forEach(formField => {
            Object.keys(formField.rules).forEach(ruleSet => {
                let rulePass;
                switch (ruleSet) {
                    case "required":
                        rulePass = this.testRule(formField, ruleSet, sel);
                        sel.formFields.filter(ff => ff.uniqueId === formField.uniqueId)[0].required = rulePass;
                        break;
                    case "optional":
                        rulePass = this.testRule(formField, ruleSet, sel);
                        sel.formFields.filter(ff => ff.uniqueId === formField.uniqueId)[0].required = !rulePass;
                        break;
                    case "disabled":
                        rulePass = this.testRule(formField, ruleSet, sel);
                        formField.rules[ruleSet].filter(rule => rule.newValue != null).forEach(rule => {
                            if (rulePass) sel.data[formField.uniqueId] = rule.newValue;
                        });
                        sel.formFields.filter(ff => ff.uniqueId === formField.uniqueId)[0].disabled = rulePass;
                        break;
                    case "hide":
                        rulePass = this.testRule(formField, ruleSet, sel);
                        sel.formFields.filter(ff => ff.uniqueId === formField.uniqueId)[0].hidden = rulePass;
                        break;
                    default:
                }
            })
        })
        return (sel);
    }

    onBlur = (e) => {
        this.props.log('FormDisplay.js/onBlur (e)', e.target.name, e.target.value);
        e.persist();
        let sel = { ...this.state };
        this.state.formFields.filter(formField => Object.keys(formField.rules).length > 0).forEach(formField => {
            Object.keys(formField.rules).forEach(ruleSet => {
                switch (ruleSet) {
                    case "copy":
                        formField.rules[ruleSet].filter(rule => rule.key != null).forEach(rule => {
                            if (sel.data[formField.uniqueId] === '' || (formField.type === 'select' && sel.data[formField.uniqueId] === -1)) sel.data[formField.uniqueId] = sel.data[rule.key];
                        })
                        break;
                    default:
                }
            })
        })
        sel.targetFields != null && sel.targetFields.filter(targetField => targetField.field === e.target.name).forEach(targetField => {
            switch (targetField.attribute) {
                case "min":
                    if (new Date(e.target.value + 'T00:00:00').getTime() < (new Date(sel.targetFieldsValue + 'T00:00:00').getTime() + (3600 * 1000 * 24))) {
                        sel.data[e.target.name] = "";
                    }
                    break;
                default:
            }
        })
        this.setState(sel);
    }

    onChangeField = (name, value, index) => {
        this.props.log('FormDisplay.js/onChangeField (name, value, index)', name, value, index);
        // e.persist();
        this.setState((prevState) => {
            let sel = prevState;
            sel.selection[name] = value;
            for (let i = (index + 1); i < Object.keys(sel.selection).length; i++) {
                sel.selection[Object.keys(sel.selection)[i]] = -1;
            }
            sel.joinData = {};
            this.getTargetFormFields(name, value, sel, true);
            return sel;
        }, () => {
            this.state.config.criteria.forEach(criteria => {
                if (criteria.filter != null) {
                    if (this.state.selection[criteria.filter] != null && this.state.selection[criteria.filter] !== -1)
                        this.getFormFields(criteria.uniqueId, criteria.filter);
                }
            });
            let isMet = true;
            this.state.config.criteria.forEach(criteria => {
                if (criteria.required && this.state.criteria[criteria.uniqueId] != null &&
                    (this.state.selection[criteria.uniqueId] == null || this.state.selection[criteria.uniqueId] === '-1')) isMet = false;
                this.getJoinFormData(criteria);
            });
            if (isMet) {
                let retArr = [];
                this.state.config.criteria.forEach(criteria => {
                    if (this.state.criteria[criteria.uniqueId] != null && this.state.selection[criteria.uniqueId] != null && this.state.selection[criteria.uniqueId] !== '-1') {
                        let sel = {};
                        sel[criteria.uniqueId] = this.state.selection[criteria.uniqueId];
                        retArr.push(sel);
                    }
                });
                this.setState({
                    criteriaString: JSON.stringify(retArr)
                }, () => this.getFormEntries());
            }
        })
    }

    getTargetFormFields = (name, value, sel = this.state, loadData) => {
        this.props.log('FormDisplay.js/getTargetFormFields (name, value, sel)', name, value, sel);
        if (sel.config.lookup != null) {
            sel.config.lookup.forEach(lookup => {
                if (name === lookup.lookupColumn) {
                    fetch('/api/form-data-field/', {
                        method: 'POST',
                        body: JSON.stringify({
                            keyColumn: lookup.keyColumn,
                            keyInput: lookup.keyInput,
                            returnColumn: lookup.returnColumn,
                            dataColumn: lookup.dataColumn,
                            dataInput: value
                        }),
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + this.props.clientToken
                        }
                    })
                        .then(results => results.json())
                        .then(results => {
                            if (results.success && results.data.length > 0) {
                                this.setState({
                                    targetFields: lookup.targetFields,
                                    targetFieldsValue: results.data[0].value
                                }, () =>
                                    loadData && this.getFormEntries())
                            } else {
                                this.setState({
                                    targetFields: [],
                                    targetFieldsValue: null
                                })
                            }
                        })
                        .catch(() => {
                            this.props.addToast('An error has occurred attempting to retrieve a form value.', 5, 'danger');
                        })
                }
            })
        }
    }

    getJoinFormData = (criteria) => {
        this.props.log('FormDisplay.js/getJoinFormData (criteria)', criteria);
        if (criteria.joinForm != null && this.state.selection[criteria.joinForm.joinTargetUniqueId] != null) {
            fetch('/api/get-form-entries/', {
                method: 'POST',
                body: JSON.stringify({
                    formId: criteria.joinForm.formId,
                    criteria: ''

                }),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.props.clientToken,
                    'X-DB': this.props.clientId
                }
            })
                .then(results => results.json())
                .then(results => {
                    if (results.success) {
                        let targetArr = results.data.filter(row => row.data[criteria.joinForm.joinDataUniqueId] === this.state.selection[criteria.joinForm.joinTargetUniqueId]);
                        if (targetArr.length === 1) {
                            targetArr = targetArr[0].data;
                            let sel;
                            this.setState((prevState) => {
                                sel = prevState;
                                // let obj = {};
                                Object.keys(targetArr).forEach(key => {
                                    sel.joinData[key] = targetArr[key];
                                });
                                //  let intersectData = this.intersect(sel.data,sel.originalData)
                                // sel.data = { ...targetArr, ...sel.joinData };
                                return sel;
                            }, () => this.setState({
                                formFields: this.applyRules(sel).formFields
                            }))
                        }
                    } else {
                        this.props.addToast('Unable to load data form.', 5, 'danger');
                    }
                })
                .catch(() => {
                    this.props.addToast('An error has occurred attempting to load a data form.', 5, 'danger');
                })
        }
    }

    formatDate = (date) => {
        this.props.info('FormDisplay.js/formatDate (date)', date);
        return (typeof (date) === 'object') ?
            date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0') : date;
    }

    submitDisabled = () => {
        this.props.info('FormDisplay.js/submitDisabled');
        let disabled = false;
        let duplicate = false;
        this.state.formFields.filter(field => field.required).forEach(field => {
            if (this.state.data[field.uniqueId] === ''
                || (String(this.state.data[field.uniqueId]).toLowerCase().indexOf('same') > -1)
                || (String(this.state.data[field.uniqueId]).toLowerCase().indexOf('today') > -1)
                || (field.type === 'select' && this.state.data[field.uniqueId] === '-1')
                || (field.type === 'number' && parseFloat(this.state.data[field.uniqueId]) === 0)) disabled = true;
        });
        if (this.state.config != null && this.state.config.unique != null && this.state.config.unique.length > 0) {
            this.state.formEntries.forEach((entry) => {
                let prevOuter = 0;
                prevOuter += this.state.config.unique.reduce((prevInner, field) => {
                    if (entry.data[field] != null && entry.data[field] !== '' && this.state.data[field] != null && this.state.data[field] !== ''
                        && parseInt(entry.formEntryId) !== parseInt(this.state.selectedFormEntry)) {
                        prevInner += (entry.data[field].toLowerCase().trim() === this.state.data[field].toLowerCase().trim()) ? 1 : 0;
                    }
                    return prevInner;
                }, 0);
                if (prevOuter === this.state.config.unique.length) duplicate = true;
            });
        }
        if (this.state.config != null && this.state.config.uniqueSingles != null && this.state.config.uniqueSingles.length > 0) {
            this.state.formEntries.forEach((entry) => {
                let prevOuter = 0;
                prevOuter += this.state.config.uniqueSingles.reduce((prevInner, field) => {
                    if (entry.data[field] != null && entry.data[field] !== '' && this.state.data[field] != null && this.state.data[field] !== ''
                        && parseInt(entry.formEntryId) !== parseInt(this.state.selectedFormEntry)) {
                        prevInner += (entry.data[field].toLowerCase().trim() === this.state.data[field].toLowerCase().trim()) ? 1 : 0;
                    }
                    return prevInner;
                }, 0);
                console.log('revo',prevOuter)
                if (prevOuter > 0) duplicate = true;
            });
        }
        if (duplicate) disabled = true;
        return { disabled: disabled, duplicate: duplicate };
    }

    cancelForm = () => {
        this.setFocus();
        this.setState({
            selectedFormEntry: 0,
            autofocus: true,
            userCreated: {},
            userUpdated: {},
            data: this.setFormState(this.state.formFields, {})
        })
    }

    submitForm = () => {
        this.props.log('FormDisplay.js/submitForm');
        let submitObj = {};
        this.state.formFields.forEach(field => {
            switch (field.type) {
                case "select":
                    if (parseInt(this.state.data[field.uniqueId]) !== -1) submitObj[field.uniqueId] = this.state.data[field.uniqueId];
                    break;
                case "number":
                    if (parseInt(this.state.data[field.uniqueId]) !== 0) submitObj[field.uniqueId] = this.state.data[field.uniqueId];
                    break;
                default:
                    if (this.state.data[field.uniqueId] !== '') submitObj[field.uniqueId] = this.state.data[field.uniqueId];
                    break;
            }
        })
        fetch('/api/form-entries/' + (this.state.selectedFormEntry > 0 ? this.state.selectedFormEntry : ''), {
            method: this.state.selectedFormEntry > 0 ? 'PUT' : 'POST',
            body: JSON.stringify({
                formId: this.props.formId,
                data: JSON.stringify(submitObj),
                uniqueId: null,
                date: new Date(),
                active: true,
                criteria: this.state.criteriaString,
                dateUpdated: new Date(),
                userCreated: this.props.user,
                userUpdated: this.props.user
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-DB': this.props.clientId
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.props.addToast('Form entry posted.', 5, 'success')
                    console.log('HERE',this.state.selectedFormEntry,this.state.config.identifier,this.state.data[this.state.config.identifier],this.state.originalData[this.state.config.identifier],this.state.data[this.state.config.identifier] !== this.state.originalData[this.state.config.identifier])
                    if (this.state.selectedFormEntry > 0 && this.state.config.identifier != null &&
                        (this.state.data[this.state.config.identifier] !== this.state.originalData[this.state.config.identifier])) {
                            fetch('/api/replace-form-entries/', {
                                method: 'POST',
                                body: JSON.stringify({
                                    oldStr: this.state.originalData[this.state.config.identifier],
                                    newStr: this.state.data[this.state.config.identifier]
                                }),
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': 'Bearer ' + this.props.clientToken,
                                    'X-DB': this.props.clientId
                                }
                            })
                    }  
                    this.getFormEntries();
                    if (!this.state.limit) {
                        let sel = { ...this.state }
                        this.setState({
                            selectedFormEntry: 0,
                            autofocus: true,
                            userCreated: {},
                            userUpdated: {},
                            data: this.setFormState(this.state.formFields, submitObj)
                        }, () => {
                            sel.data = this.setFormState(this.state.formFields, submitObj);
                            this.setState({
                                formFields: this.applyRules(sel).formFields
                            })
                        })
                    }
                } else {
                    this.props.addToast('Unable to post form entry.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred attempting to post a form entry.', 5, 'danger');
            })
    }

    loadData = (entry) => {
        this.props.log('FormDisplay.js/loadData (entry)', entry);
        this.setState((prevState) => {
            let obj = prevState;
            let originalData = this.setFormState(this.state.formFields, {});
            obj.data = { ...originalData, ...entry.data }
            obj.originalData = { ...originalData, ...entry.data }
            this.state.formFields.filter(formField => formField.type === 'select').forEach(formField => {
                this.getTargetFormFields(formField.uniqueId,obj.data[formField.uniqueId],obj,false);
            })
            obj.selectedFormEntry = entry.formEntryId;
            if (entry.userCreated != null && entry.userCreated.length > 0) obj.userCreated = { ...entry.userCreated[0], dateCreated: entry.dateCreated };
            if (entry.userUpdated != null && entry.userUpdated.length > 0) obj.userUpdated = { ...entry.userUpdated[0], dateUpdated: entry.dateUpdated };
            return obj;
        }, () => {
            window.scrollTo({
                top: 0,
                behavior: 'auto'
            });
        })
    }

    onChangeFilter = (e) => {
        this.props.log('FormDisplay.js/onChangeFilter (e)', e.target.name, e.target.value);
        e.persist();
        this.setState((prevState) => {
            let sel = prevState;
            sel.filter[e.target.name] = e.target.value;
            return sel;
        })
    }

    getFormattedDate = (date) => {
        this.props.info('FormDisplay.js/getFormattedDate (date)', date);
        let year = date.getFullYear()//.toString().substr(2, 2);
        let month = (1 + date.getMonth())/*.toString().padStart(2, '0')*/;
        let day = date.getDate()/*.toString().padStart(2, '0')*/;
        return month + '/' + day + '/' + year;
    }

    getFormattedField = (val, type) => {
        this.props.info('FormDisplay.js/getFormattedField (val,type)', val, type);
        if (val == null || val === '') return val;
        switch (type) {
            case "date":
                return this.getFormattedDate(new Date(val.substr(0, 4), parseInt(val.substr(5, 2)) - 1, val.substr(8, 2), 0, 0, 0));
            case "number":
                return Intl.NumberFormat().format(parseFloat(val));
            case "select":
                return (parseInt(val) === -1) ? '' : val;
            case "currency":
                return new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD',
                }).format(val);
            default:
                return val;
        }
    }

    formatAMPM = (date) => {
        this.props.info('FormDisplay.js/formatAMPM (date)', date);
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
    }

    orderEntries = (arr, obj) => {
        this.props.info('FormDisplay.js/orderEntries (arr,obj)', arr, obj);
        if (obj != null) {
            if (obj.type === 'currency' || obj.type === 'number') {
                arr.sort(function (a, b) {
                    var numA = a.data[obj.uniqueId] != null ? parseFloat(a.data[obj.uniqueId]) : '';
                    var numB = b.data[obj.uniqueId] != null ? parseFloat(b.data[obj.uniqueId]) : '';
                    if (obj == null || obj.asc == null || obj.asc) {
                        return (numA < numB) ? -1 : (numA > numB) ? 1 : 0;
                    } else {
                        return (numA < numB) ? 1 : (numA > numB) ? -1 : 0;
                    }
                });
            } else {
                arr.sort(function (a, b) {
                    var textA, textB;
                    if (obj.uniqueId === 'enteredDate') {
                        textA = a.date;
                        textB = b.date;
                    } else {
                        textA = a.data[obj.uniqueId] != null ? a.data[obj.uniqueId].toUpperCase() : '';
                        textB = b.data[obj.uniqueId] != null ? b.data[obj.uniqueId].toUpperCase() : '';
                    }
                    if (obj == null || obj.asc == null || obj.asc) {
                        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                    } else {
                        return (textA < textB) ? 1 : (textA > textB) ? -1 : 0;
                    }
                });
            }
            return arr;
        } else {
            return arr;
        }
    }

    setSort = (field, type) => {
        this.props.log('FormDisplay.js/setSort (field,type)', field, type);
        this.setState({
            sortAsc: (this.state.sort === field) ? !this.state.sortAsc : true,
            sortType: type,
            sort: field
        })
    }

    displayCriteriaAndEntries = (sidebarColumn) => {
        return (
            <>
                {this.state.config.criteria != null ?
                    <Row className="mb-4 px-2">
                        {this.state.config.criteria.map((criteria, criteriaIndex) => (
                            <Col key={criteria.uniqueId} md={4}>
                                {criteria.filter == null || (criteria.filter != null && this.state.selection[criteria.filter] != null && this.state.selection[criteria.filter] !== -1) ?
                                    <Input
                                        type="select"
                                        onChange={(e) => this.onChangeField(e.target.name, e.target.value, criteriaIndex)}
                                        name={criteria.uniqueId}
                                        value={this.state.selection[criteria.uniqueId]}
                                    >
                                        <option value="-1">Select {criteria.field}</option>
                                        {this.state.criteria[criteria.uniqueId] != null ?
                                            <>
                                                {this.state.criteria[criteria.uniqueId][0] != null &&
                                                    this.state.criteria[criteria.uniqueId][0].options[0] != null &&
                                                    this.state.criteria[criteria.uniqueId][0].options[0].options != null ?
                                                    this.state.criteria[criteria.uniqueId][0].options[0].options.split('\n').map((option, optionIndex) => (
                                                        <option key={optionIndex}>{option.replaceAll('\\/', '/')}</option>
                                                    )) : null}
                                            </>
                                            : null}
                                    </Input> : null}
                            </Col>
                        ))}
                    </Row>
                    : null}
                <FormEntries
                    log={this.props.log}
                    info={this.props.info}
                    {...this.state}
                    isCriteriaMet={this.isCriteriaMet}
                    setSort={this.setSort}
                    isFieldNull={this.props.isFieldNull}
                    orderEntries={this.orderEntries}
                    getFormattedField={this.getFormattedField}
                    getFormattedDate={this.getFormattedDate}
                    formatAMPM={this.formatAMPM}
                    deleteEntry={this.deleteEntry}
                    onChangeFilter={this.onChangeFilter}
                    loadData={this.loadData}
                />
            </>
        )
    }

    displayFormEntry = (sidebarColumn) => {
        const colWidth = (sidebarColumn != null && sidebarColumn) ? 12 : 6;
        return (<>
            {
                Object.keys(this.state.data).length > 0 && this.isCriteriaMet() && (!this.state.config.hideInputFields || this.state.selectedFormEntry > 0) ?
                    <>
                        <Row className="font-weight-bold headerBanner my-0 py-2">
                            {this.state.selectedFormEntry === 0 ? <Col>New Entry</Col> : <Col>Editing Entry</Col>}
                        </Row>
                        <Row className={sidebarColumn ? "formSidebarFields" : ""}>
                            {this.state.formFields.map((field, fieldIndex) => {
                                if (field.uniqueId === '' || field.field === '' || (field.hidden != null && field.hidden)) return (null);
                                if (field.type === 'header') return (
                                    <Col md={12}>
                                        <h4 className="my-3">{field.field}</h4>
                                    </Col>
                                )
                                return (
                                    <Col key={fieldIndex} md={colWidth}>
                                        <Row>
                                            <Col className={"formLabel pt-1" +
                                                (field.required ? ' required' : '') +
                                                (field.required && (this.state.data[field.uniqueId] === ''
                                                    || (field.type === 'select' && (this.state.data[field.uniqueId] === '-1' || this.state.data[field.uniqueId] === 'same'))
                                                    || (field.type === 'number' && parseFloat(this.state.data[field.uniqueId]) === 0)) ? ' formError' : '')
                                            } md={4}>
                                                {field.field}{field.required ? '*' : null}
                                            </Col>
                                            <Col className="formInput mb-2 px-1" >
                                                <FormRenderField
                                                    field={field}
                                                    fieldIndex={(fieldIndex + 1) * 1000}
                                                    log={this.props.log}
                                                    info={this.props.info}
                                                    data={this.state.data}
                                                    config={this.state.config}
                                                    onChange={this.onChange}
                                                    onBlur={this.onBlur}
                                                    isFieldNull={this.props.isFieldNull}
                                                    targetFields={this.state.targetFields}
                                                    targetFieldsValue={this.state.targetFieldsValue}
                                                />
                                                {/* {this.renderField(field, fieldIndex + 1)} */}
                                            </Col>
                                        </Row>
                                    </Col>
                                )
                            })}
                        </Row>
                    </> : <>
                        <Row className="font-weight-bold headerBanner my-0 py-2">
                            <Col>&nbsp;</Col>
                        </Row>
                        <Row className={sidebarColumn ? "formSidebarFields" : ""}></Row></>
            }
            < Row className="pt-2 pb-4 px-2 formSidebarSubmit border-top" >
                <Col md={5} className="text-left pl-0 pr-1">
                    <Button tabIndex={this.state.formFields.length + 2} color="primary" disabled={this.submitDisabled().disabled} onClick={this.submitForm}>Submit</Button>
                    {this.state.selectedFormEntry > 0 ? <Button tabIndex={this.state.formFields.length + 3} color="secondary" onClick={this.cancelForm}>Cancel</Button> : null}
                    {this.submitDisabled().duplicate ? <p className="text-danger m-2">Duplicate Entry</p> : null}
                </Col>
                <Col md={7} className="text-right entryCreatedUpdated pl-1 pr-0">
                    {Object.keys(this.state.userCreated).length > 0 ? <p>Entered by {this.state.userCreated.firstName} {this.state.userCreated.lastName} on {this.getFormattedDate(new Date(this.state.userCreated.dateCreated))} </p> : null}
                    {Object.keys(this.state.userUpdated).length > 0 ? <p>Last updated by {this.state.userUpdated.firstName} {this.state.userUpdated.lastName} on {this.getFormattedDate(new Date(this.state.userUpdated.dateUpdated))} </p> : null}
                    {this.state.targetFieldsValue != null ? <p><strong>Books closed date: {this.getFormattedDate(new Date(this.state.targetFieldsValue + 'T00:00:00'))}</strong></p> : null}
                </Col>
            </Row >
        </>
        )
    }

    render() {
        this.props.info('FormDisplay.js/render');
        return (
            <>
                {
                    this.state.config.sidebarColumn != null && this.state.config.sidebarColumn ?
                        <Container className="text-left" fluid>
                            <link rel="stylesheet" type="text/css" href={'/sidebar.css'} />
                            <Row className="text-left my-0 ">
                                <Col className='formSidebar border-right'>
                                    {this.displayFormEntry(true)}
                                </Col>
                                <Col className="formContent p-0 pt-0">
                                    {this.displayCriteriaAndEntries()}
                                </Col>

                            </Row>
                        </Container>
                        :
                        <Container>
                            <Row className='pb-5'>
                                <Col className='px-5'>
                                    {this.displayFormEntry()}
                                </Col>
                            </Row>
                            <Row className="text-left my-0">
                                <Col className="px-5 p-0 pt-0">
                                    {this.displayCriteriaAndEntries()}
                                </Col>
                            </Row>
                        </Container>
                }
            </>
        );
    }
}

export default FormDisplay;